module.exports = __webpack_public_path__ + "static/media/share.d2ab7b81.svg";